import { Outlet } from 'react-router-dom'
import { BillingViewProvider } from 'pages/settings/pages/billing/context/billingViewContext'

export const BillingPageLayout = () => {
  return (
    <BillingViewProvider>
      <Outlet />
    </BillingViewProvider>
  )
}
